import { map, option, task } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import * as applicative from './applicative.js';
import * as apply from './apply.js';
import * as chain from './chain.js';
export * from 'fp-ts/Task';
export const ChainSeq = {
    ...task.Chain,
    ap: task.ApplySeq.ap,
};
export const sequenceS = apply.sequenceS(task.ApplyPar);
export const sequenceSeqS = apply.sequenceS(task.ApplySeq);
export const sequenceT = apply.sequenceT(task.ApplyPar);
export const sequenceSeqT = apply.sequenceT(task.ApplySeq);
export const bindSequenceS = chain.bindSequenceS(task.Chain);
export const bindSequenceSeqS = chain.bindSequenceS(ChainSeq);
export const bindS = chain.bindS(task.Chain);
export const chainSequenceS = chain.chainSequenceS(task.Chain);
export const chainSequenceSeqS = chain.chainSequenceS(ChainSeq);
export const run = (t) => t();
export const map2 = apply.map2(task.ApplyPar);
export const map3 = apply.map3(task.ApplyPar);
export const fromPromiseK = ((f) => (...args) => () => f(...args));
/**
 * Given a function and an `Eq` instance for determining input equivalence,
 * returns a new function that caches the result of applying an input to said
 * function. If the cache hits, the cached value is returned and the function
 * is not called again. Useful for expensive computations.
 */
export const memoize = (eq) => (f) => {
    const cache = new Map();
    return (k) => async () => {
        const cached = map.lookup(eq)(k)(cache);
        if (option.isSome(cached))
            return cached.value;
        const val = await pipe(f(k), run);
        cache.set(k, val);
        return val;
    };
};
export const chainFirstVoid = (f) => (fa) => () => Promise.resolve()
    .then(fa)
    .then((a) => (f(a), a));
export const flatTraverseIO = (f) => (ta) => () => Promise.resolve()
    .then(ta)
    .then((a) => f(a)());
export const when = applicative.when(task.ApplicativeSeq);
export const withTimeout = (timeoutMillis, onTimeout) => (fa) => task
    .getRaceMonoid()
    .concat(fa, pipe(task.of(undefined), task.delay(timeoutMillis), task.map(onTimeout)));
//# sourceMappingURL=task.js.map